import React from 'react';
import { styles } from './index';

export type InputHintProps = {
  id?: string;
  hint: string;
};

export const InputHint = ({ id, hint }: InputHintProps) => {
  return (
    <div className={styles.hint} id={`${id}_hint`}>
      {hint}
    </div>
  );
};
